// extracted by mini-css-extract-plugin
module.exports = {"component":"radio-component--3RdUG"};